<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号:">
          <el-input size="small" v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="售后类型">
          <el-select v-model="searchForm.type" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="退款" value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="searchForm.createTime" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="-1"></el-tab-pane>
          <el-tab-pane label="进行中" name="0">
            <span slot="label">进行中 ({{ order_count ? order_count.is_progress : 0 }})</span>
          </el-tab-pane>
          <el-tab-pane label="已拒绝" name="10">
            <span slot="label">已拒绝 ({{ order_count.is_refuse }})</span>
          </el-tab-pane>
          <el-tab-pane label="已完成" name="20">
            <span slot="label">完成 ({{ order_count.is_completed }})</span>
          </el-tab-pane>
          <el-tab-pane label="已取消" name="30">
            <span slot="label">已取消 ({{ order_count.is_cancel }})</span>
          </el-tab-pane>
        </el-tabs>

        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <!-- <el-table-column prop="orderNo" label="订单号" width="130"></el-table-column> -->
          <!-- <el-table-column prop="orderproduct.productName" width="400" label="商品信息">
            <template slot-scope="scope">
              <div class="d-s-c">
                <img v-img-url="scope.row.orderproduct.image.filePath" alt="" width="50px" />
                <div class="flex-1 ml10">
                  <p>
                    <span class="gray9">订单号：</span>
                    <span class="green">{{ scope.row.orderNo }}</span>
                  </p>
                  <p class="text-ellipsis-2 lh18">{{ scope.row.orderproduct.productName }}</p>
                </div>
              </div>
            </template>
          </el-table-column> -->

          <el-table-column prop="orderId" align="center" label="订单ID"></el-table-column>
          <el-table-column prop="orderNo" align="center" label="订单编号"></el-table-column>

          <el-table-column prop="type.text" align="center" label="售后类型">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="apply_desc" align="center" label="申请原因"></el-table-column>
          <el-table-column prop="refuse_desc" align="center" label="审核建议"></el-table-column>
          <el-table-column prop="refund_money" align="center" label="实际退款金额">
            <template slot-scope="scope">
              <span class="red">￥{{ scope.row.refund_money }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="param" label="可退金额">
            <template slot-scope="scope" v-if="scope.row.param">
              <p class="gray6">
                <span class="gray9">可退金额:</span>
                {{ scope.row.param.price }}
              </p>
              <p class="gray6">
                <span class="gray9">描述：</span>
                {{ scope.row.param.status_text }}
              </p>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="可退金额" width="200">
            <template slot-scope="scope" v-if="scope.row.param">
              <el-input class="max-w460" placeholder="请输入" v-model="price">
                <el-button slot="append" icon="el-icon-search" @click="changeprice"></el-button>
              </el-input>
            </template>
          </el-table-column> -->

          <el-table-column prop="orderMaster.order_source_text" align="center" label="订单类型"></el-table-column>
          <!-- <el-table-column prop="plate_status" label="平台介入"></el-table-column> -->

          <el-table-column prop="user.nickName" align="center" label="买家信息">
            <template slot-scope="scope">
              <span>{{ scope.row.user.nickName }}</span>
              <br />
              <span>{{ scope.row.user.mobile }}</span>
              <br />
              <span class="gray9">(ID:{{ scope.row.user.user_id }})</span>

            </template>
          </el-table-column>
          <el-table-column prop="supplier.name" align="center" label="商家信息">
            <template slot-scope="scope">
              <span>{{ scope.row.supplier.name }}</span>
              <br />
              <span>{{ scope.row.supplier.real_name }}</span>
              <br />
              <span class="gray9">(ID:{{ scope.row.supplier.user_id }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="时间" width="200">
            <template slot-scope="scope">
              <p class="gray6">
                <span class="gray9">售后申请：</span>
                {{ scope.row.update_time }}
              </p>
              <p class="gray6">
                <span class="gray9">下 单：</span>
                {{ scope.row.createTime }}
              </p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="Detailclick(scope.row)" type="primary" size="small">售后详情</el-button>
              <!-- v-if="scope.row.is_agree.value == 0 || scope.row.is_agree.value==20" -->
              <!-- :disabled="scope.row.is_agree.value" -->
              <!-- <el-button @click="agreeclick(scope.row)" type="text" size="small">审核</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--审核-->
      <Examine v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')">
      </Examine>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import Examine from "./examine";
import { deepClone } from "@/utils/base.js";
import qs from "qs";
export default {
  components: {
    /*审核组件*/
    Examine
  },
  data() {
    return {
      /*切换菜单*/
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        orderNo: "",
        type: "",
        createTime: "",
        status: ""
      },
      activeName: "-1",
      /*时间*/
      order_count: {},
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    changeprice() { },
    /*切换菜单*/
    handleClick(tab, event) {
      this.curPage = 1;
      // this.status = tab.name;
      this.getData();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.status = self.activeName;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      OrderApi.orderrefund(Params, true)
        .then(res => {
          self.tableData = res.data.list.data;
          self.order_count = res.data.order_count ? res.data.order_count : {};
          self.totalDataNumber = res.data.list.total;
          self.loading = false;
        })
        .catch(error => { });
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.orderId;
      self.$router.push({
        path: "/order/order/Detail",
        query: {
          orderId: params
        }
      });
    },
    /*打开审核*/
    agreeclick(item) {
      this.userModel = deepClone(item);
      console.log("============", item, this.userModel);
      this.open_edit = true;
    },
    // 售后详情
    Detailclick(e) {
      let self = this;
      let order_refund_id = e.order_refund_id;
      this.$router.push({
        path: "/order/refund/detail",
        query: {
          order_refund_id: order_refund_id
        }
      });
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    }
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>
<style lang="scss" scoped>
.img {
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/refund/index.vue